import { useOutletContext } from "react-router-dom";
import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadSalesOrders = async () => {
  try {
    const response = await Axios.get('sales-orders');
    const responseData = await response.data;
    return responseData;
    // return []
  }catch (err) {
    throw err;
  }
};

export const loadOrderToInvoice = async () => {
  try {
    const response = await Axios.get('sales-orders/to-invoice');
    const responseData = await response.data;
    return responseData;
    // return []
  }catch (err) {
    throw err;
  }
};

export const loadQuotations = async () => {
  try {
    const response = await Axios.get('sales-orders/quotations');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};


export const loadPOTransfer = async (number, document) => {
  try {
    const filter = encodeURI(JSON.stringify({number: number, document: document}));
    const respnse = await Axios.get('sales-orders/transfer/'+filter);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadPOTransfers = async (action) => {
  try {
    const respnse = await Axios.get('sales-orders/transfers/all/'+action);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

const loadOneQuotation = async (name) => {
  try {
    const respnse = await Axios.get('sales-orders/find/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadSalesOrder = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/sales-orders');
        const responseData = await response.data;
        return {...responseData, salesOrder: {}};
        // return {taxes: [], products: [], contacts:[], operationTypes:[], quotation:{}};
        
      default:
        const data = await loadOneQuotation(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const useSalesOrderAPI = () => {
  const { success, error } = useOutletContext();


  const create = async (data) => {
    try {
      const respnse = await Axios.post('sales-orders', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('sale_response', responseData.number);
    }catch(err) {
      console.log(err);
    }
  }

  const update = async (seo, data) => {
    try {
      const respnse = await Axios.put('sales-orders/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('sale_response', data.seo);
    }catch (err) {
      throw err;
    }
  }

  const confirm = async (number, data) => {
    try {
      const respnse = await Axios.patch('sales-orders/'+number.replaceAll('/', '-'), data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('purchase_order_confirmed', number);
    }catch (err) {
      if (err.code === 'ERR_NETWORK') {
        error("Couldn't process request. Please check your network connectivity");
      }else {
        console.log(err)
        error(err.response.data.message);
      }
      throw err;
    }
  }

  const validate = async (data) => {
    try {
      const respnse = await Axios.put('sales-orders/validate/transfer', data);
      const responseData = await respnse.data;
      success(responseData.message);
      // EventEmitter.dispatch('sale_response', data.seo);
    }catch (err) {
      throw err;
    }
  }

  const removeProductLine = async (id) => {
    try {
      const response = await Axios.delete('/sales-orders/orderline/'+id);
      const responseData = await response.data;
      success(responseData.message);
    }catch (err) {
      if (err.code === 'ERR_NETWORK') {
        error("Couldn't process request. Please check your network connectivity");
      }else {
        error(err.response?.data?.message);
      }
      throw err;
    }
  }

  const removeOptionalLine = async (id) => {
    try {
      const response = await Axios.delete('/sales-orders/optionals/'+id);
      const responseData = await response.data;
      success(responseData.message);
    }catch (err) {
      if (err.code === 'ERR_NETWORK') {
        error("Couldn't process request. Please check your network connectivity");
      }else {
        error(err.response?.data?.message);
      }
      throw err;
    }
  }

  return { create, update, confirm, validate, removeProductLine, removeOptionalLine };
};



export default useSalesOrderAPI;


